import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import CurrencySelector from '../../../components/CurrencySelector';
import DatePicker from '../../../components/DatePicker/index';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';

export class DynamicDatePicker extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  onChangeResetReceived = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    item.dateSelected = '';
    this.change(item);
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  render() {
    const { item } = this.props;
    const {
      disabled,
      removable,
      validatorGroup,
      validationCounter,
    } = this.props;

    return (
      
        <div className='row'>
          <div className="form-group col-5 mt-1">
                <Validate
                  name="dateSelected"
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required, checkDateOnly]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  defaultValue={item.dateSelected}
                  fieldName={messages.treatmentDate}
                >
                  <DatePicker
                    disabled={disabled}
                    name="dateSelected"
                    type="text"
                    onDayChange={this.handleDayChange('dateSelected')}
                    value={item.dateSelected}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.treatmentDate}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.treatmentDate}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
          <div className="form-group col-4">
            {!disabled &&
                removable && (
                <div className="form-group mt-4">
                    <Button onClick={this.onRemoveClick}>Remove</Button>
                </div>
                )}
            {/* <div className="form-group col-auto">
                <PageSectionHeader>
                <FormattedMessage {...messages.itemWithIdx} values={{ idx: this.props.index + 1 }} />
                </PageSectionHeader>
            </div> */}
          </div>
        </div>
    );
  }
}

DynamicDatePicker.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.MedicalExpenseStep/components/DynamicDatePicker/DynamicDatePicker.js